import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { OrgNoteEditor } from "@/components/org-note-editor";
import { useTRPC } from "@/trpc";

interface TimeEntryOrgNoteProps {
  timeEntryId: string;
  organizationBusinessUnitId: string;
  orgNote: string | null;
  canEdit: boolean;
  popover?: boolean;
  onSaved: () => void;
}

export function TimeEntryOrgNote({
  timeEntryId,
  organizationBusinessUnitId,
  orgNote,
  canEdit,
  popover = false,
  onSaved,
}: TimeEntryOrgNoteProps) {
  const trpc = useTRPC();
  const [open, setOpen] = useState(false);

  const updateMutation = useMutation(
    trpc.timeEntry.updateOrgNote.mutationOptions({
      onSuccess: () => {
        toast.success("Org note saved");
        setOpen(false);
        onSaved();
      },
      onError: (error) => {
        toast.error(error.message || "Failed to save org note");
      },
    }),
  );

  return (
    <OrgNoteEditor
      orgNote={orgNote}
      canEdit={canEdit}
      popover={popover}
      inputId={`organization-note-${timeEntryId}`}
      open={open}
      onOpenChange={setOpen}
      isSaving={updateMutation.isPending}
      onSave={(nextOrgNote) =>
        updateMutation.mutate({
          organizationBusinessUnitId,
          timeEntryId,
          orgNote: nextOrgNote,
        })
      }
    />
  );
}
